import type { FC } from "react";

import { swSettings } from "app/common/services/swSettings";
import SocialTraffic from "app/pages/website-analysis/social-overview/socialTraffic/SocialTraffic";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";
import { getHooksVersion } from "app/UtilitiesAndConstants/UtilityFunctions/hooksUtils";
import { isNoTouchOrTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOSocialOverviewContainerDS: FC = () => {
    const getCtaLink = (params) => {
        return {
            href: proNavigator.href("digitalsuite_website_social_overview", params),
            target: "_self",
        };
    };
    return (
        <SocialTraffic
            getCtaLink={getCtaLink}
            unlockHook={{
                component: "WsWebSocialTrafficOverview",
                hookModal: isNoTouchOrTrialOrAfterTrial(swSettings) ? "socialOverview" : DEFAULT_HOOKS_MODAL_ID,
                version: getHooksVersion(swSettings),
            }}
        />
    );
};
